module.exports = __webpack_public_path__ + "fonts/981ccbbd3f322cb55c1e4a02d247dae4-Audiowide-Regular.ttf";